import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';

import { INDDFormPopupData } from './shared/ndd-ng-form-popup.model';

/** Componente popup. */
@Component({
    selector: 'ndd-ng-form-popup',
    template: require('./ndd-ng-form-popup.component.html'),
})
export class NDDFormPopupComponent implements OnInit, AfterViewChecked {
    /** Id do popup. */
    @Input() public popupId: string;
    /** Lista de dados. */
    @Input() public popupData: INDDFormPopupData[];
    /** Valor inicial selecionado. */
    @Input() public popupSelectedValue: any;
    /** Exibir popup. */
    @Input() public popupShow: boolean;
    /** Altura máxima da listagem de itens. */
    @Input() public popupMaxHeight?: string;
    /** Largura da listagem de itens. */
    @Input() public popupWidth?: string;
    /** Apresenta popup acima do campo */
    @Input() public popupOnTop?: boolean;

    /** Evento de seleção de item; na inicialização do componente. */
    @Output() public onPopupInitValue: EventEmitter<INDDFormPopupData> = new EventEmitter();
    /** Evento de seleção de item. */
    @Output() public onPopupSelectedValue: EventEmitter<INDDFormPopupData> = new EventEmitter();

    @ViewChildren('listItem') public listItems: QueryList<ElementRef>;
    @ViewChild('popup', { static: false }) public popup: ElementRef;

    private alreadyScrolled: boolean = false;

    public ngOnInit(): void {
        if (this.popupSelectedValue || this.popupSelectedValue === 0) {
            const selectedData: INDDFormPopupData = this.popupData
                .filter((data: INDDFormPopupData) => data.value === this.popupSelectedValue)[0];

            this.onPopupInitValue.emit(selectedData);
        }
    }

    public ngAfterViewChecked(): void {
        // Posicionamento do scroll, conforme item selecionado.
        if (this.popupShow && !this.alreadyScrolled) {
            this.listItems
                .forEach((item: ElementRef, index: number) => {
                    if (item.nativeElement.className.includes('--selected')) {
                        const itemHeight: number = item.nativeElement.offsetHeight;
                        const popupHeight: number = this.popup.nativeElement.offsetHeight;

                        /**
                         * Cálculo para descobrir onde o scroll deve se posicionar.
                         *
                         * (altura do item da lista * quantidade de itens até o atual) - altura do popup
                         */
                        this.popup.nativeElement.scrollTop = (itemHeight * (index + 1)) - popupHeight;

                        this.alreadyScrolled = true;
                    }
                });
        }

        if (!this.popupShow) {
            this.alreadyScrolled = false;
        }
    }

    /**
     * Seleção de item.
     *
     * @param {INDDFormPopupData} data Item.
     * @memberof NDDFormPopupComponent
     */
    public selected(data: INDDFormPopupData): void {
        if (!data.disabled) {
            this.popupSelectedValue = data.value;
            this.onPopupSelectedValue.emit(data);
        }
    }

    /**
     * Define a classe do item.
     *
     * @param {INDDFormPopupData} data Item.
     * @returns {string} Classe.
     * @memberof NDDFormPopupComponent
     */
    public getItemClass(data: INDDFormPopupData): string {
        let itemClass: string = 'ndd-ng-form-internal-popup__list__item';

        if (data.value === this.popupSelectedValue) {
            itemClass += ' ndd-ng-form-internal-popup__list__item--selected';
        }
        if (data.disabled) {
            itemClass += ' ndd-ng-form-internal-popup__list__item--disabled';
        }

        return itemClass;
    }
}
